import { GeolocationRequestInterface } from '../../../interfaces/request/geolocation/geolocation-request-interface';

export class CpGeolocationRequestModel implements GeolocationRequestInterface {
  latitude: number = 0;
  longitude: number = 0;

  constructor(init?: Partial<CpGeolocationRequestModel>) {
    Object.assign(this, init);
  }
}
